import EntityType from '@enums/EntityType';

const baseMetrics = () => {
  return {
    activities: 0,
    budget: 0,
    cost: 0,
    count: 0,
    allocatedFTE: 0,
    fte: 0,
    groups: 0,
    hours: 0,
    roles: 0,
    people: 0,
    span: 0,
  };
};

export default function getMetrics(item) {
  if (!item?.entity) {
    return {
      ...baseMetrics(),
      [EntityType.ACTIVITY]: baseMetrics(),
      [EntityType.GROUP]: baseMetrics(),
      [EntityType.ROLE]: baseMetrics(),
      ids: {
        entities: new Set(),
        [EntityType.ACTIVITY]: new Set(),
        [EntityType.ROLE]: new Set(),
        [EntityType.GROUP]: new Set(),
        [EntityType.MANAGER]: new Set(),
      },
    };
  }

  const { entity } = item;

  const metrics =
    entity.__type === EntityType.GROUP
      ? entity.__metrics.span.visible
      : entity.__metrics.self.visible;

  return {
    activities: metrics.activities || 0,
    budget: metrics.budget || 0,
    cost: metrics.cost || 0,
    count: 1,
    allocatedFTE: metrics.allocatedFTE || 0,
    fte: metrics.fte || 0,
    groups: metrics.groups || 0,
    hours: metrics.hours || 0,
    roles: metrics.roles || 0,
    people: metrics.people || 0,
    span: 0,
  };
}
